import { Component, DestroyRef, OnInit, input, inject } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { map, tap, debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { Customer } from '@app/core/stingray-api/models';
import { requireMatch } from '@app/validators/autocomplete-validator';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { CustomersService } from '@app/core/stingray-api/services';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';

@Component({
    selector: 'unite-tax-partner-autocomplete',
    templateUrl: './tax-partner-autocomplete.component.html',
    styleUrls: ['./tax-partner-autocomplete.component.scss'],
    imports: [MatFormField, MatLabel, MatProgressSpinner, MatSuffix, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, TranslateModule, MatIcon]
})
export class TaxPartnerAutocompleteComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  control = input<FormControl>();
  required = input(false);
  focus = input(false);
  label = input<string>();

  taxPartners: Customer[] = [];
  taxPartnersFiltered: Customer[];

  isLoadingTaxPartners = false;

  constructor(
    private customersService: CustomersService) { }

  ngOnInit() {
    if (this.required() === false) {
      this.control().setValidators([requireMatch]);
    } else {
      this.control().setValidators([Validators.required, requireMatch]);
    }

    this.control().valueChanges.pipe(
      tap(() => this.isLoadingTaxPartners = true),
      debounceTime(350),
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef),
      switchMap((value: any) => {
        if (value && typeof value === 'string' && value.trim() !== '') {
          return this.customersService.getCustomers({
            name: value,
            types: ['Person']
          }).pipe(map(data => data.items), catchError(() => of(null)));
        } else {
          this.isLoadingTaxPartners = false;
          return of(null);
        }
      })).subscribe((taxPartnersFiltered: Customer[]) => {
        this.taxPartnersFiltered = taxPartnersFiltered;
        this.isLoadingTaxPartners = false;
      });
  }

  displayWithCustomer(taxPartner: Customer): string {
    if (taxPartner != null) {
      return taxPartner.name;
    } else {
      return '';
    }
  }

  isCustomer(value: any | Customer): value is Customer {
    return value != null && (<Customer>value).id !== undefined;
  }
}
